export const getEmail = state => state.smsemailReducer.email;
export const getSms = state => state.smsemailReducer.sms;
// export const getActiveTab = state => state.smsemailReducer.activeTab;


// WEBPACK FOOTER //
// src/store/selector/smsemail.selector.js